import React, { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Route, Switch } from 'react-router-dom'

import { CssBaseline, ThemeProvider, Theme } from '@mui/material'
import { LoginConfiguration } from '@professocial/professocialTypes/types/configurationTypes'

import { setUser } from '../store/user/user.actions'
import getDefaultTheme from '../config/getDefaultTheme'

import ForgotPassword from '../shared/components/LoginComponents/ForgotPassword'
import Login from '../shared/components/LoginComponents/Login'
import RegisterConfirmSuccess from '../shared/components/LoginComponents/RegisterConfirmSuccess'
import RegisterConfirmError from '../shared/components/LoginComponents/RegisterConfirmError'

export interface LoginProps {
  loginConfiguration?: LoginConfiguration
}

const ProfessocialLogin: React.FC<LoginProps> = (props) => {
  const dispatch = useDispatch()
  const dispatchSetUser = useCallback((params: any) => dispatch(setUser(params)), [dispatch])

  const theme: Theme = props.loginConfiguration?.theme || getDefaultTheme()

  useEffect(() => {
    const logoutListener = () => dispatchSetUser(null)
    window.addEventListener('ProfessocialLogout', logoutListener)

    return () => {
      window.removeEventListener('ProfessocialLogout', logoutListener)
    }
  }, [dispatchSetUser])

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Switch>
          <Route exact path={['/login', '/resetPassword/:token']}>
            <Login loginConfiguration={props.loginConfiguration} />
          </Route>
          <Route exact path='/registerSuccess'>
            <RegisterConfirmSuccess />
          </Route>
          <Route exact path='/registerError'>
            <RegisterConfirmError />
          </Route>
        </Switch>
      </ThemeProvider>
    </>
  )
}

export default ProfessocialLogin
